import Promise from 'promise'
import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  get () {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/findocs')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/findoc-resource.js